import { useState, useLayoutEffect } from 'react';
import { TIMEOUTS } from 'src/app/constants';

function useDelayedRender(delayTimeout?: number) {
  const [delay, setDelay] = useState(true);

  useLayoutEffect(() => {
    const timeout = setTimeout(() => setDelay(false), delayTimeout ?? TIMEOUTS.DELAY_SCREEN_RENDER);

    return () => clearTimeout(timeout);
  }, [delayTimeout]);

  return delay;
}

export default useDelayedRender;
